import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { helper } from "../../componets/utils/helper";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import VotersService from "../../services/VotersService";
import { APP_TYPE, formatDate } from "../../config/Config";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import EventService, { eventService } from "../../services/EventService";
import { Dropdown } from "primereact/dropdown";
import { UserDelimitation } from "../users/UserDelimitation";
import { delimitationService } from "../../services/DelimitationService";
import { InputTextarea } from "primereact/inputtextarea";
import LocalDelimitation from "../../componets/LocalDelimitation";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { reportService } from "../../services/ReportService";
import ScreenLoader from "../../componets/ScreenLoader";
import { PrintOut } from "../reports/PrintOut";
import GenericFileCapture from "../../componets/GenericFileCapture";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";
import DocumentTypesService from "../../services/DocumentsService";
import MultiFilterSearch from "../../componets/MultiFilterSearch";

export default function PoliticalPartyAgent({ header = null }) {
	var { selectedParty, isOnlyView } = useContext(PoliticalPartyDBContext);
	var political = new PoliticalPartyService();
	var [agentList, setAgentList] = useState([]);
	var [eventGroup, setEventGroup] = useState([]);
	var [event, setEvent] = useState([]);
	var [eventsMapping, setEventsMapping] = useState([]);
	var [loading, setLoading] = useState(false);
	var [refresh, setRefresh] = useState(false);
	var [isNational, setIsNational] = useState(false);
	var [votingStation, setVotingStation] = useState([]);
	const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });

	var [showAddDialog, setShowAddDialog] = useState({
		show: false,
		voterRecord: null,
		idNumber: "",
		village: null,
		delimitationID: null,
		delimitationLevelID: null,
		event: null
	});
	var { toast, lookUp } = useContext(AppDB);
	var political = new PoliticalPartyService();
	var voter = new VotersService();
	var eventServices = new EventService();

	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([])
	var [loading, setLoading] = useState(false);
	var [agentDocumentTypes, setAgentDocuments] = useState([]);

	var documentService = new DocumentTypesService();
	useEffect(() => {
		documentService.getDocumentTypes(3).then(res => {
			setAgentDocuments(res)
		})

	}, [])

	useEffect(() => {
		//get event groups

		eventService
			.getAllEvents({
				PageIndex: 1,
				PageSize: 100000,
				IsPoliticalPaty: true,
				ActiveOnly: true
			})
			.then((res) => {
				setEventsMapping(res);
				setLoading(false);
			});
	}, [selectedParty, refresh]);

	useEffect(() => {
		setLoading(true);
		//get agent members
		political
			.getPartyAgentMembersByParty({
				...delimitation,
				politicalPartyID: selectedParty.politicalPartyID,
				eventID: showAddDialog.event?.eventID
			})
			.then((res) => {
				setAgentList(res.agents);
				//get event groups
				eventServices.getAllGroups().then((groups) => {
					//get active event groups
					const list = [];

					for (var group of groups) {
						if (group.status == 1) {
							list.push(group);
						}
					}

					setEventGroup(list);
					setLoading(false);
				});
			});
	}, [selectedParty, refresh, delimitation]);

	useEffect(() => {
		if (showAddDialog.eventGroupID !== null) {
			setLoading(true);
			eventServices
				.getAllEvents({
					EventGroupID: showAddDialog.eventGroupID,
					PageIndex: 1,
					PageSize: 100000,
					IsPoliticalPaty: true,
					ActiveOnly: true
				})
				.then((_event) => {
					//get active event groups
					setEvent(_event);
					setLoading(false);
				});
		}
	}, [showAddDialog.eventGroupID]);

	function searchVoterByIDNumber() {
		setLoading(true);
		voter.getByIDNumber(showAddDialog.idNumber).then((res) => {
			console.log(res);
			var status = `${res}`;

			if (res?.eligibleStatus === "N") {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not eligible",
					life: 2500
				});
				return
			}
			if (status.trim().length === 0) {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
			} else {
				delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
					setLoading(false);
					setVotingStation(delim);

					var contactNumber = "";

					res?.contactDetails.forEach((contact) => {
						if (contact?.contactType?.name === "Cellphone") {
							contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
							return;
						}
					});

					setShowAddDialog({
						...showAddDialog,
						village: res?.village,
						voterRecord: {
							contactNumber: contactNumber,
							firstname: res.firstname,
							surname: res.surname,
							dateOfBirth: res.dateOfBirth,
							gender: res.gender,
							voterID: res.voterID
						}
					});
				});
			}
		});
	}

	function searchVoterByFilter(idNumber) {
		setLoading(true);
		voter.getByIDNumber(idNumber).then((res) => {
			console.log(res);
			var status = `${res}`;

			if (res?.eligibleStatus === "N") {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not eligible",
					life: 2500
				});
				return
			}
			if (status.trim().length === 0) {
				setLoading(false);
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
			} else {
				delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
					setLoading(false);
					setVotingStation(delim);

					var contactNumber = "";

					res?.contactDetails.forEach((contact) => {
						if (contact?.contactType?.name === "Cellphone") {
							contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
							return;
						}
					});

					setShowAddDialog({
						...showAddDialog,
						village: res?.village,
						voterRecord: {
							contactNumber: contactNumber,
							firstname: res.firstname,
							surname: res.surname,
							dateOfBirth: res.dateOfBirth,
							gender: res.gender,
							voterID: res.voterID
						}
					});
				});
			}
		});
	}

	const handleAddAgent = async (event) => {
		setLoading(true);

		var docum = JSON.parse(JSON.stringify(fileUploaderDocuments));




		docum = docum.map(doc => {
			var _do = doc.binaryData.split(",");
			if (_do.length >= 2) {
				doc.binaryData = _do[1];
			}
			return doc;
		})
		political
			.addPartyAgentMemberByParty({
				politicalPartyID: selectedParty.politicalPartyID,
				voterID: showAddDialog.voterRecord.voterID,
				eventID: showAddDialog.event.eventID,
				delimitationID: showAddDialog.delimitationID,
				delimitationLevelID: showAddDialog.delimitationLevelID,
				contactNumber: showAddDialog.voterRecord.contactNumber,
				physicalAddress: showAddDialog.voterRecord.physicalAddress,
				documents: docum
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setShowAddDialog({
						...showAddDialog,
						show: false,
						voterRecord: null,
						idNumber: "",
					});
					setRefresh(!refresh);
					toast.show({
						severity: "success",
						detail: "Elector Added",
						life: 2500
					});
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	};

	const confirmDeleteAgent = (e, row) => {
		confirmDialog({
			target: e.currentTarget,
			message: "Are you sure you want to proceed?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				setLoading(true);
				political.deletePartyAgent(row?.eventAgentID).then((res) => {
					setLoading(false);
					if (res.success) {
						setRefresh(!refresh);
						toast.show({
							severity: "success",
							detail: "Agent Removed",
							life: 2500
						});
					} else {
						toast.show({
							severity: "error",
							detail: res.message,
							life: 2500
						});
					}
				});
			},
			reject: () => { }
		});
	};


	const [selectedEvent, setselectedEvent] = useState(null)
	const [showReport, setshowReport] = useState(false)
	const handleDownloadReport = () => {
		var payload = {
			ReportID: 23,
			PoliticalPartyID: selectedParty?.politicalPartyID,
			eventid: selectedEvent?.eventID,
			delimitationID: showAddDialog.delimitationID,
			delimitationLevelID: showAddDialog.delimitationLevelID,
		};
		getReport(payload);
	};
	const [base64, setBase64] = useState(null);
	const [fetchReportLoader, setfetchReportLoader] = useState(false)
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = (data) => {
		console.log("Report Parameters:", data);
		setfetchReportLoader(true)
		reportService.getReport(data).then((response) => {
			setfetchReportLoader(false);

			if (response?.success) {
				setshowReport(true);
				setBase64(response.data);
				toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
			} else {
				toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
			}
		})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};
	console.log(selectedEvent)
	return (
		<>
			<ScreenLoader visible={fetchReportLoader} />
			<PrintOut base64={base64} setBase64={setBase64} showDialog={showReport} setShowDialog={setshowReport} />
			<ConfirmDialog />
			<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>{header !== null && <h5>{header}</h5>}</div>

			<div className="card">
				{(<>
					<b>
						Select Event <span style={{ color: "red" }}>*</span>
					</b>

					<div className="grid ">
						<div className="md:col-6 col-12">
							<Dropdown
								className="w-full"
								value={showAddDialog.event}
								options={eventsMapping}
								optionLabel="name"
								onChange={(e) => {
									setShowAddDialog({ ...showAddDialog, event: e.value });
									setselectedEvent(e.target.value)
								}}
							/>
						</div>
						<div className="md:col-6 col-12 ">
							<Button
								disabled={showAddDialog.event === null || [null, undefined, ""].includes(delimitation.delimitationID)}
								label="Add Agent"
								loading={loading}
								onClick={() => {
									setShowAddDialog({ ...showAddDialog, show: true });
								}}
								className="p-button-success mr-1 ml-2"
							/>

							<Button
								// disabled={selectedEvent === null}
								label="Print"
								loading={loading}
								onClick={() => {
									handleDownloadReport()
								}}
								className="p-button-primary w-[120px]"
							/>
						</div>

					</div>
					<br />
				</>)}



				{showAddDialog.event !== null && <LocalDelimitationNational
					key={JSON.stringify(showAddDialog?.event)}
					showFilter={false}
					grid="3"
					isNational={showAddDialog?.event?.isNationalDelimitation}
					level2Star={showAddDialog?.event?.isNationalDelimitation ? "" : "*"}
					level3Star={showAddDialog?.event?.isNationalDelimitation ? "" : "*"}
					level4Star=""

					politicalDelimitation={showAddDialog?.event}
					onChange={(delimitationID, delimitationLevelID, isLastLevel) => {
						setShowAddDialog({ ...showAddDialog, delimitationID: delimitationID, delimitationLevelID });
						setDelimitation({ delimitationID, delimitationLevelID });
					}}
					onFilter={(e) => {
						setDelimitation({ ...e });
					}}
				/>}

			</div>

			<Dialog
				header={
					<>
						<h5 className="my-0">
							Add Agent - <small>{showAddDialog?.event?.name}</small>
						</h5>
					</>
				}
				style={{ width: "100%", maxWidth: "1000px" }}
				onHide={() => {
					setShowAddDialog({
						...showAddDialog,
						show: false,
						voterRecord: null,
						idNumber: ""
					});
				}}
				visible={showAddDialog.show}
				footer={
					<>
						<Button disabled={showAddDialog.voterRecord === null} loading={loading} onClick={handleAddAgent} label="Submit" />
						<Button
							className="p-button-danger"
							onClick={() =>
								setShowAddDialog({
									...showAddDialog,
									show: false,
									voterRecord: null,
									idNumber: ""
								})
							}
							label="Close"
						/>
					</>
				}
			>
				{/* <hr /> */}
				{/* <div className="col-12 f-bold">
					<b>Search Elector</b>
				</div> */}
				{/* <div className=" flex my-2">
					<InputText
						maxLength={12}
						style={{ width: "100%" }}
						placeholder="National ID"
						value={showAddDialog.idNumber}
						onChange={(e) => {
							setShowAddDialog({ ...showAddDialog, idNumber: e.target.value.trim().toLowerCase() });
						}}
					/>
		
					<Button
						className="ml-2"
						loading={loading}
						disabled={showAddDialog.idNumber.length !== 12}
						label="Search"
						onClick={() => {
							searchVoterByIDNumber();
						}}
					/>
				</div> */}

				<div className="col-12">
					<MultiFilterSearch
						label={<>Search By <span style={{ color: "red" }}>*</span></>}
						onClear={() => {
							setShowAddDialog({ ...showAddDialog, voterRecord: null, idNumber: "" });
						}}
						onChange={res => {
							searchVoterByFilter(res.idNumber)

							setShowAddDialog({ ...showAddDialog, idNumber: res.idNumber });

						}} />
				</div>
				{showAddDialog.voterRecord !== null && (
					<>
						<hr></hr>

						<div className="grid">
							<div className="col-12  md:col-6 ">
								<b>Event</b>
								<div className=" p-inputtext p-component p-filled">{showAddDialog?.event?.name}</div>
							</div>

							<div className="col-12  md:col-6">
								<b>First Name</b>
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.firstname}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Surname</b>
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.surname}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Date Of Birth</b>
								<div className=" p-inputtext p-component p-filled">{formatDate(showAddDialog.voterRecord.dateOfBirth)}</div>
							</div>

							<div className="col-12  md:col-6 ">
								<b>Contact Number</b>
								<InputText
									className="w-full"
									value={showAddDialog.voterRecord.contactNumber}
									onChange={(e) => {
										showAddDialog.voterRecord.contactNumber = e.target.value;
										setShowAddDialog({ ...showAddDialog });
									}}
								/>
							</div>

							<div className="col-12  md:col-12 ">
								<b>Physical Address</b>
								<InputTextarea
									onChange={(e) => {
										showAddDialog.voterRecord.physicalAddress = e.target.value;
										setShowAddDialog({ ...showAddDialog });
									}}
									className="w-full"
									value={showAddDialog.voterRecord.physicalAddress}
								/>
							</div>
						</div>
						<hr></hr>

						<div className="col-12">
							<GenericFileCapture
								dontClearDocuments={true}
								refresh={refresh} setRefresh={setRefresh}
								key={JSON.stringify(showAddDialog)}
								extraAttributes={{
									// "candidateID": selectedCanditate.candidateID,
									// "eventID": showCandidateDialog?.event?.eventID
								}}
								documentTypesLookUp={agentDocumentTypes} show={showFileUploader} setShow={setShowFileUploader}
								setDocuments={setFileUploaderDocuments}
								documents={fileUploaderDocuments}
							/>
							<GenericUploadFileTable
								header={<div className="col-12  lg:col-3 my-2">
									<label htmlFor="description">
										Upload Documents
									</label>
									<br />
									<>
										<Button
											label={"Upload"}
											onClick={() => setShowFileUploader(true)}
											className="p-button-success"
											icon={"pi pi-plus"}
										/>
									</>
								</div>}
								setDocuments={setFileUploaderDocuments}
								documents={fileUploaderDocuments}
							/>
						</div>

						{/* <LocalDelimitationNational
                            politicalDelimitation={showAddDialog?.event?.isNationalDelimitation ? showAddDialog.village : showAddDialog?.event}
                            isNational={showAddDialog?.event?.isNationalDelimitation}
                            onChange={(delimitationID, delimitationLevelID, isLastLevel) => {
                                setShowAddDialog({ ...showAddDialog, delimitationID: delimitationID });
                            }}
                        /> */}
					</>
				)}
			</Dialog>

			<DataTable
				size="small"
				scrollable={true}
				scrollHeight="400px"
				value={agentList}
				dataKey="id"
				loading={loading}
				rowsPerPageOptions={[5, 10, 25]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
				emptyMessage="No members found."
				responsiveLayout="scroll"
				// selection={selectedMember}
				// onSelectionChange={(e) => setSelectedMember(e.value)}
				resizableColumns
				columnResizeMode="expand"
				// filters={filters}
				filterDisplay="Name"
				globalFilterFields={["Name"]}
			>
				<Column field="registrationNumber" header="Registration Number" sortable></Column>
				<Column field="firstname" header="Name" sortable></Column>
				<Column field="surname" header="Surname" sortable></Column>
				<Column field="delimitation" header="Demarcation" sortable></Column>
				<Column field="delimitationName" header="Demarcation Name" sortable></Column>

				<Column
					field="actions"
					header="Actions"
					body={(e) => (
						<>
							<Button
								disabled={isOnlyView}
								onClick={(ee) => confirmDeleteAgent(ee, e)}
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-trash"}
								className="p-button-danger p-button-rounded mr-2"
								tooltip="Click to delete"
							/>
						</>
					)}
				></Column>
			</DataTable>
		</>
	);
}
